import React from 'react';

export type ThemeChoice = 'light' | 'auto' | 'dark';

export const THEME_CYCLE: ThemeChoice[] = ['light', 'auto', 'dark'];
const THEME_LABEL: Record<ThemeChoice, string> = { light: 'Light', auto: 'Auto', dark: 'Dark' };

interface Props {
  venueName: string | null;
  venueLogoUrl: string | null;
  subtitle: string | null;
  theme: ThemeChoice;
  onCycleTheme: () => void;
  onShare: () => void;
}

/**
 * Dark venue-branded band — consistent in BOTH themes (it is the shared
 * family with the QR landing). Hosts the guest theme pill and the share
 * affordance (the same URL the printed QR encodes).
 */
const Masthead: React.FC<Props> = ({ venueName, venueLogoUrl, subtitle, theme, onCycleTheme, onShare }) => {
  const monogram = (venueName ?? 'Wine List')
    .split(/\s+/)
    .map(w => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <header className="lc-masthead">
      <div className="lc-mast-controls">
        <button type="button" className="lc-mastbtn" aria-label="Share this menu" onClick={onShare}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M12 3v12" /><path d="m7 8 5-5 5 5" /><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7" />
          </svg>
        </button>
        <button type="button" className="lc-mastbtn lc-themepill" aria-label="Switch appearance" onClick={onCycleTheme}>
          {THEME_LABEL[theme]}
        </button>
      </div>
      {venueLogoUrl
        ? <img className="lc-mast-logo" src={venueLogoUrl} alt="" />
        : <div className="lc-monogram lc-serif" aria-hidden="true">{monogram}</div>}
      <h1>{venueName ?? 'Wine List'}</h1>
      {subtitle && <p>{subtitle}</p>}
    </header>
  );
};

export default Masthead;
